import React from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import DiariaDesk from './DiariaDesk'
import DiariaMob from './DiariaMob'

export default function Diaria() {
  const { sttAuthCtx } = React.useContext(AuthContext)

  React.useEffect(() => {
    document.title = 'Diárias | Agendei Quadras'
  }, [])

  return <>{sttAuthCtx.isMobile ? <DiariaMob /> : <DiariaDesk />}</>
}
